<onyx-modal
  variant="right"
  [heading]="pointOfInterest()?.name ?? ''"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="pointOfInterest$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container headingButtons>
    @if (pointOfInterest(); as pointOfInterest) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="edit-outlined"
        [circle]="true"
        onyxTooltip="labels.edit"
        (click)="edit()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="telephone-outlined"
        [circle]="true"
        onyxTooltip="labels.call"
        (click)="ActionHelper.makeCall(pointOfInterest.phone)"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="share-outlined"
        [circle]="true"
        onyxTooltip="labels.share"
        (click)="share()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="options-vertical-filled"
        [circle]="true"
        [onyxDropdownOptions]="options()"
        [onyxDropdownDisabled]="!options()?.length"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        onyxTooltip="labels.options"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>
    }
  </ng-container>

  @if (pointOfInterest(); as pointOfInterest) {
    <div class="container">
      <onyx-map [defer]="true"></onyx-map>

      <section>
        <onyx-information-heading>
          {{ 'labels.location' | translate }}
        </onyx-information-heading>

        <onyx-information-list>
          <onyx-information-row label="labels.address">
            <onyx-address
              [address]="pointOfInterest.address"
              format="short"
            ></onyx-address>

            <div class="copy">
              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="24"
                icon="copy-filled"
                (click)="copyAddress(pointOfInterest.address)"
              ></onyx-icon-button>
            </div>
          </onyx-information-row>

          <onyx-information-row label="labels.coordinates">
            <onyx-address
              [address]="pointOfInterest.address"
              format="coordinates"
            ></onyx-address>

            <div class="copy">
              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="24"
                icon="copy-filled"
                (click)="copyCoordinates(pointOfInterest.address)"
              ></onyx-icon-button>
            </div>
          </onyx-information-row>
        </onyx-information-list>
      </section>

      <section>
        <onyx-information-heading>
          {{ 'labels.openingHours' | translate }}
        </onyx-information-heading>

        @let businessHours = pointOfInterest.businessHours;
        <onyx-information-list>
          <onyx-information-row
            [label]="
              businessHours | businessHours: 'weekday' : 'long' : 'label'
            "
          >
            {{ businessHours | businessHours: 'weekday' : 'long' : 'value' }}
          </onyx-information-row>

          <onyx-information-row
            [label]="
              businessHours | businessHours: 'saturday' : 'long' : 'label'
            "
          >
            {{ businessHours | businessHours: 'saturday' : 'long' : 'value' }}
          </onyx-information-row>

          <onyx-information-row
            [label]="businessHours | businessHours: 'sunday' : 'long' : 'label'"
          >
            {{ businessHours | businessHours: 'sunday' : 'long' : 'value' }}
          </onyx-information-row>
        </onyx-information-list>
      </section>

      <section>
        <onyx-information-heading>
          {{ 'labels.times' | translate }}
        </onyx-information-heading>

        <onyx-information-row label="labels.averageServiceTime">
          {{
            pointOfInterest.time.averageServiceTime | duration: { units: ['h'] }
          }}
        </onyx-information-row>
      </section>

      <section>
        <onyx-information-heading>
          {{ 'labels.contactData' | translate }}
        </onyx-information-heading>

        <onyx-information-row label="labels.phone">
          {{ pointOfInterest.phone | onyxPhone }}

          @if (pointOfInterest.phone; as phone) {
            <div class="copy">
              <onyx-icon-button
                variant="transparent"
                color="gray"
                [size]="24"
                icon="copy-filled"
                (click)="copyPhone(phone)"
              ></onyx-icon-button>
            </div>
          }
        </onyx-information-row>
      </section>

      <div class="chips">
        <onyx-chips
          [chips]="sections()"
          variant="secondary"
          [single]="true"
          [gap]="8"
          [(activeValues)]="section"
        ></onyx-chips>
      </div>

      @switch (section()[0]) {
        @case (PointOfInterestModalSection.ASSIGNED_CONTRACTORS) {
          <onyx-table
            [data]="pointOfInterest.contractors"
            [columns]="COLUMNS"
            [tableShadow]="false"
            [rowSize]="48"
            [(pagination)]="pagination"
            [notFound]="NOT_FOUND"
            (rowClick)="openModal($event.item.contractor)"
          ></onyx-table>
        }
        @case (PointOfInterestModalSection.NOTE) {
          <app-modal-note
            [note]="pointOfInterest.note"
            [route]="
              PointsOfInterestRoute.EDIT_POINT_OF_INTEREST.replace(
                ':uuid',
                pointOfInterest.uuid
              )
            "
            [close$]="close$"
          ></app-modal-note>
        }
      }
    </div>
  }
</onyx-modal>
